import React from "react";
import { Spin, Image } from "antd";
import { usePromiseTracker } from "react-promise-tracker";
import Logo from "assets/images/logo.svg";

export default function Spinner({ children, flag }) {
  const { promiseInProgress } = usePromiseTracker();

  return (
    <Spin
      className={flag ? "global-spinner" : ""}
      tip={flag && <Image src={Logo} preview={false} />}
      spinning={promiseInProgress}
      size="large"
    >
      {children}
    </Spin>
  );
}
